/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import Species from "views/Species.js";
import About from "views/About.js";
import HistoryView from "views/History.js";
import WeatherView from "views/Weather.js";
import BlogView from "views/Blog.js";


var routes = [
  {
    path: "/index",
    name: "Home",
    icon: "fa fa-mountain text-primary",
    component: <Index />,
    layout: "/admin",
  },
  {
    path: "/species",
    name: "Species",
    icon: "fa fa-feather text-blue",
    component: <Species />,
    layout: "/admin",
  },
  {
    path: "/species/:name",     // ← this is what you're missing
    component: <Species />,
    layout: "/admin",
    invisible: true,            // optional: hides it from sidebar
  },
  {
    path: "/weather",
    name: "Weather",
    icon: "fa fa-cloud text-green",
    component: <WeatherView />,
    layout: "/admin",
  },
  {
    path: "/blog",
    name: "East Street Blog",
    icon: "fa fa-newspaper text-info",
    component: <BlogView />,
    layout: "/admin",
  },

  {
    path: "/history",
    name: "History",
    icon: "fa fa-timeline text-orange",
    component: <HistoryView />,
    layout: "/admin",
  },
  {
    path: "/history/:historydate",
    component: <HistoryView />,
    layout: "/admin",
    invisible: true, // hides from sidebar
  },
  {
    path: "/about",
    name: "About",
    icon: "fa fa-tree text-purple",
    component: <About />,
    layout: "/admin",
  },
];
export default routes;

/*

,
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
  }
,
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
  },

*/